/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FirmNameStyle {
    AsIs = 'AsIs',
    SmallCaps = 'SmallCaps',
    RegularCaps = 'RegularCaps'
}

export function FirmNameStyleFromJSON(json: any): FirmNameStyle {
    return FirmNameStyleFromJSONTyped(json, false);
}

export function FirmNameStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmNameStyle {
    return json as FirmNameStyle;
}

export function FirmNameStyleToJSON(value?: FirmNameStyle | null): any {
    return value as any;
}

